import {
  LOANTERM_LOADING,
  GET_LOANTERM,
  GET_LOANTERM_SUCCESS,
  GET_LOANTERM_FAIL,
  ADD_LOANTERM_SUCCESS,
  ADD_LOANTERM_FAIL,
  DELETE_LOANTERM_SUCCESS,
  DELETE_LOANTERM_FAIL,
  UPDATE_LOANTERM_SUCCESS,
  UPDATE_LOANTERM_FAIL,
  LOANTERM_RESET
} from "./actionType";

const INIT_STATE = {
  loanTerms: [],
  error: {},
};

const LoanTerm = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOANTERM_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LOANTERM:
          return {
            ...state,
            loanTerms: action.payload.data,
            isLoanTermCreated: false,
            isLoanTermSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LOANTERM_FAIL:
      switch (action.payload.actionType) {
        case GET_LOANTERM_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLoanTermCreated: false,
            isLoanTermSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LOANTERM: {
      return {
        ...state,
        isLoanTermCreated: false,
        loading: true,
      };
    }

    case LOANTERM_LOADING: {
      return {
        ...state,
        isLoanTermCreated: false,
        loading: true,
      };
    }

    case ADD_LOANTERM_SUCCESS:
      return {
        ...state,
        isLoanTermCreated: true,
        loading: false,
        loanTerms: [action.payload.data, ...state.loanTerms],
      };

    case ADD_LOANTERM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LOANTERM_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoanTermCreated: true,
        loanTerms: state.loanTerms.filter(
          loanTerm => loanTerm.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LOANTERM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LOANTERM_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoanTermCreated: true,
        loanTerms: state.loanTerms.map(loanTerm =>
          loanTerm.id.toString() === action.payload.data.id.toString() ? { ...loanTerm, ...action.payload.data } : loanTerm
        ),
      };

    case UPDATE_LOANTERM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LOANTERM_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LoanTerm;